/**
 * "just now", "12m ago", "3h ago", "4d ago", "5mo ago". The size of a gap is
 * what an operator reads first ("last login 9d ago" answers "is jane even
 * using it?"), so the user page shows it next to every exact timestamp.
 *
 * Same steps as the Telemetry page's install ages (minutes, then hours up to
 * two days, then days), plus months and years: a user record can be far
 * older than a device row. A timestamp slightly in the future (clock skew
 * between the device, the server and this browser) reads "just now" rather
 * than a negative age.
 */
export function timeAgo(iso: string | null | undefined, now: number = Date.now()): string | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return null;
  const mins = Math.round((now - t) / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 60) return `${days}d ago`;
  const months = Math.round(days / 30);
  if (months < 24) return `${months}mo ago`;
  return `${Math.round(days / 365)}y ago`;
}
